/** `editor` namespace — Swedish (source of truth). */
const editor = {
  placeholder: {
    document: 'Börja skriva här...',
    title: 'Dokumenttitel...',
    mini: 'Skriv här...',
  },
  loadingDocument: 'Laddar dokument...',
  save: 'Spara',
  saving: 'Sparar...',
  toolbar: {
    undo: 'Ångra',
    redo: 'Gör om',
    defaultFont: 'Standard',
    fontSize: 'Textstorlek',
    decreaseFontSize: 'Minska textstorlek',
    increaseFontSize: 'Öka textstorlek',
    heading1: 'Rubrik 1',
    heading2: 'Rubrik 2',
    heading3: 'Rubrik 3',
    bold: 'Fet',
    italic: 'Kursiv',
    underline: 'Understruken',
    strikethrough: 'Genomstruken',
    code: 'Kod',
    link: 'Länk',
    highlight: 'Markera',
    chooseHighlightColor: 'Välj markeringsfärg',
    highlightColor: {
      yellow: 'Gul',
      green: 'Grön',
      blue: 'Blå',
      red: 'Röd',
    },
    removeHighlight: 'Ta bort markering',
    textColor: 'Textfärg',
    alignLeft: 'Vänsterjustera',
    alignCenter: 'Centrera',
    alignRight: 'Högerjustera',
    outdent: 'Minska indrag',
    indent: 'Öka indrag',
    list: 'Lista',
    chooseListType: 'Välj listtyp',
    bulletList: 'Punktlista',
    numberedList: 'Numrerad lista',
    checkList: 'Checklista',
    insertImage: 'Infoga bild',
    table: 'Tabell',
    tableAndLayout: 'Tabell & layout',
    insertTable: 'Infoga tabell',
    columnLayout: 'Kolumnlayout',
    insertBlock: 'Infoga block',
    quote: 'Citat',
    codeBlock: 'Kodblock',
    horizontalRule: 'Horisontell linje',
    pageBreak: 'Sidbrytning',
    print: 'Skriv ut',
    download: 'Ladda ner',
    downloadPdf: 'Ladda ner PDF',
    downloadWord: 'Ladda ner Word',
    comments: 'Kommentarer',
  },
  linkDialog: {
    title: 'Infoga länk',
    description: 'Ange URL för länken.',
    urlLabel: 'URL',
    urlPlaceholder: 'https://example.com',
    cancel: 'Avbryt',
    insert: 'Infoga',
  },
  tableDialog: {
    title: 'Infoga tabell',
    description: 'Välj antal rader och kolumner.',
    rows: 'Rader',
    columns: 'Kolumner',
    cancel: 'Avbryt',
    insert: 'Infoga',
  },
  layoutDialog: {
    title: 'Infoga kolumnlayout',
    description: 'Välj en layoutmall.',
    twoEqual: '2 kolumner (lika)',
    twoSplit: '2 kolumner (25/75)',
    threeEqual: '3 kolumner (lika)',
    threeSplit: '3 kolumner (25/50/25)',
    fourEqual: '4 kolumner (lika)',
  },
  colourPicker: {
    reset: 'Återställ standardfärg',
  },
  table: {
    actions: 'Tabellåtgärder',
    addColumn: 'Lägg till kolumn',
    addRow: 'Lägg till rad',
    mergeCells: 'Slå ihop celler',
    unmergeCell: 'Dela cell',
    insertRowAbove_one: 'Infoga rad ovanför',
    insertRowAbove_other: 'Infoga {{count}} rader ovanför',
    insertRowBelow_one: 'Infoga rad nedanför',
    insertRowBelow_other: 'Infoga {{count}} rader nedanför',
    insertColumnLeft_one: 'Infoga kolumn till vänster',
    insertColumnLeft_other: 'Infoga {{count}} kolumner till vänster',
    insertColumnRight_one: 'Infoga kolumn till höger',
    insertColumnRight_other: 'Infoga {{count}} kolumner till höger',
    deleteColumn: 'Ta bort kolumn',
    deleteRow: 'Ta bort rad',
    deleteTable: 'Ta bort tabell',
    addRowHeader: 'Lägg till radrubrik',
    removeRowHeader: 'Ta bort radrubrik',
    addColumnHeader: 'Lägg till kolumnrubrik',
    removeColumnHeader: 'Ta bort kolumnrubrik',
  },
  code: {
    plainText: 'Klartext',
    copy: 'Kopiera kod',
  },
  comments: {
    title: 'Kommentarer',
    threadCount_one: '{{count}} tråd',
    threadCount_other: '{{count}} trådar',
    addComment: 'Lägg till kommentar',
    placeholder: 'Skriv en kommentar...',
    replyPlaceholder: 'Skriv ett svar...',
    cancel: 'Avbryt',
    submit: 'Kommentera',
    empty: 'Inga kommentarer ännu',
    resolvedHeading: 'Lösta ({{count}})',
    reply: 'Svara',
    resolve: 'Lös',
    reopen: 'Öppna igen',
    delete: 'Ta bort',
    hiddenReplies_one: '{{count}} svar dolt',
    hiddenReplies_other: '{{count}} svar dolda',
    collapseReplies: 'Dölj svar',
    replyCount_one: '{{count}} svar',
    replyCount_other: '{{count}} svar',
    showResolved: 'Visa lösta ({{count}})',
    hideResolved: 'Dölj lösta',
    hideAll: 'Dölj alla kommentarer',
    hiddenBadge: 'Kommentarer dolda',
    menuTitle: 'Kommentarer',
    resolved: 'Löst',
    textChanged: 'Texten har ändrats',
    wholeBlock: 'Hela blocket',
    removedBlock: 'Blocket är borttaget',
    newComment: 'Ny kommentar',
    allComments: 'Alla kommentarer',
    openCount_one: '{{count}} öppen',
    openCount_other: '{{count}} öppna',
    submitHint: 'Ctrl+Enter skickar',
    bold: 'Fet',
    italic: 'Kursiv',
    underline: 'Understruken',
    link: 'Länk',
    linkUrl: 'Länkadress',
    linkApply: 'Lägg till',
    linkRemove: 'Ta bort länk',
    discardTitle: 'Släng kommentaren?',
    discardBody: 'Du har en osparad kommentar.',
    discardConfirm: 'Släng',
    keepEditing: 'Fortsätt skriva',
    errorHasReplies: 'Ta bort svaren innan du tar bort kommentaren',
    errorMissing: 'Kommentaren finns inte längre',
    errorGeneric: 'Kommentaren kunde inte sparas',
    deleteTitle: 'Ta bort kommentaren?',
    deleteConfirm: 'Ta bort',
    loadingComposer: 'Laddar…',
  },
  mentions: {
    noMatch: 'Ingen medlem matchar',
    former: 'Inte längre medlem i projektet',
  },
  blocks: {
    connecting: 'Ansluter…',
    offline: 'Frånkopplad – återansluter…',
    exportPdf: 'Ladda ner som PDF',
    uploadFile: 'Ladda upp fil',
    fileUrlPlaceholder: 'Klistra in en länk…',
    embed: 'Bädda in',
    uploadFailed: 'Uppladdningen misslyckades',
    print: 'Skriv ut',
    exportDocx: 'Ladda ner som Word',
    download: 'Ladda ner',
    exportFailed: 'Exporten misslyckades',
    loading: 'Laddar dokument…',
    agentWriting: 'HUB skriver…',
    pageBreak: 'Sidbrytning',
    askHub: 'Fråga HUB om detta block',
    comment: 'Kommentera',
    blocksSelected_one: '{{count}} block valt',
    blocksSelected_other: '{{count}} block valda',
    clearSelection: 'Rensa markering',
    changedBlocks: 'Ändrade block',
    undoTurn: 'Ångra',
    undone: 'Ändringarna ångrades',
    undoFailed: 'Kunde inte ångra',
    jumpTo: 'Gå till block',
    bubbleTitle: 'HUB',
    bubbleHint: 'Fråga HUB om dokumentet',
    bubblePlaceholder: 'Fråga HUB eller be om ändringar…',
    bubbleWithSelection: 'Vad vill du göra med markeringen?',
    quickImprove: 'Förbättra',
    quickSummarize: 'Sammanfatta',
    quickContinue: 'Fortsätt skriva',
    quickImprovePrompt: 'Förbättra språket i de markerade blocken utan att ändra innebörden.',
    quickSummarizePrompt:
      'Sammanfatta de markerade blocken till några få meningar och ersätt dem med sammanfattningen.',
    quickContinuePrompt:
      'Fortsätt skriva efter de markerade blocken i samma stil, ett par stycken.',
    collapse: 'Minimera',
    open: 'Öppna HUB',
    commentsForBlock: 'Kommentarer på blocket',
    removedBlocks: 'Borttagna block',
    sendToHub: 'Skicka till HUB',
    noOpenComments: 'Inga öppna kommentarer',
    resolved: 'Löst',
  },
}

export default editor
